import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class OBBasvuruListeAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "ObBasvuruListe";
        super(baseUrl);
    }


    getOBBasvuruListe(sicilKodu?: number, basvuruTuru?: number, basvuruNo?: number) {
        var request = new OBBasvuruListeRequest(sicilKodu, basvuruTuru, basvuruNo);
        return this.post("", request, false);
    }

}
export default new OBBasvuruListeAPI();
class OBBasvuruListeRequest {
    public sicilKodu?: number;
    public basvuruTuru?: number;
    public basvuruNo?: number;
    constructor(sicilKodu?: number, basvuruTuru?: number, basvuruNo?: number) {
        this.sicilKodu = sicilKodu;
        this.basvuruTuru = basvuruTuru;
        this.basvuruNo = basvuruNo;

    }
}
export { OBBasvuruListeRequest };
